import { useEffect, useState } from 'react';

export function useHeight() {
  const [height, setHeight] = useState<number>();

  useEffect(() => {
    const handleResize = () => {
      setHeight(window.outerHeight);
    };

    handleResize();
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  });

  return height;
}
